import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { AlertWarningCircleIcon } from '@calendly/ui/components/icons'

import { HoursAndDateOverrides, PendingUserAvailabilitySelect } from './components'
import { PanelContentContainer } from '../../styles'

// i18n-tasks-use I18n.t('publisher.event_type_editor.sections.available_hours.pending_host_warning.banner')
// i18n-tasks-use I18n.t('publisher.event_type_editor.sections.available_hours.pending_host_warning.banner_with_link')
export const PendingMemberAvailableHours = ({ formPath, isReadOnly = false }) => {
  const [{ value }] = useFormField({ name: formPath })
  const { usingCustomHours } = value

  const isReadOnlyAvailability = !usingCustomHours || isReadOnly

  return (
    <PanelContentContainer>
      <PendingUserAvailabilitySelect formPath={formPath} />
      <ContextualBanner icon={AlertWarningCircleIcon} variant={usingCustomHours ? 'warning' : 'subtle'}>
        {usingCustomHours
          ? I18n.t('publisher.event_type_editor.sections.available_hours.pending_host_warning.custom_schedule')
          : I18n.t('publisher.event_type_editor.sections.available_hours.pending_host_warning.default_schedule')}
      </ContextualBanner>
      {usingCustomHours && (
        <HoursAndDateOverrides
          readOnly={isReadOnlyAvailability}
          formPath={formPath}
          isMultiHost
          fixTimezonePositioning
        />
      )}
    </PanelContentContainer>
  )
}
